import { gql } from '@apollo/client';

/** Liste publique des packages (marketplace) — mêmes champs que pour les cartes agence */
export const GET_MARKETPLACE_PACKAGES = gql`
  query GetMarketplacePackages {
    packages {
      id
      title
      description
      image
      groupSize
      category
      type
      departure
      cities
      countries
      departures {
        id
        departureDate
        returnDate
      }
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
          quadruple
          quintuple
        }
      }
      agency {
        id
        name
        logo
        rating
        verified
        theme {
          primaryColor
          secondaryColor
        }
      }
      airline {
        id
        name
        code
        logo
      }
    }
  }
`;

export const GET_PACKAGE_DETAILS = gql`
  query GetPackageDetails($id: Int!) {
    package(id: $id) {
      id
      title
      description
      image
      groupSize
      category
      type
      departure
      departures {
        id
        departureDate
        returnDate
      }
      highlights
      included
      excluded
      cities
      countries
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
          quadruple
          quintuple
        }
        discountPercent
        services
        hotels {
          id
          name
          stars
          image
          address
          amenities
          meals
          bookingUrl
        }
      }
      itinerary {
        id
        dayNumber
        title
        description
        activities
        meals {
          breakfast
          lunch
          dinner
        }
        accommodation
      }
      programPdf
      airline {
        id
        name
        code
        logo
      }
      agency {
        id
        name
        subdomain
        domainType
        logo
        description
        email
        phone
        address
        rating
        verified
        yearsExperience
        satisfiedTravelers
        facebook
        instagram
        tiktok
        theme {
          primaryColor
          secondaryColor
          textColor
          backgroundColor
          headerStyle
          font
        }
      }
      similarPackages {
        id
        title
        description
        image
        departure
        category
        type
        departures {
          id
          departureDate
          returnDate
        }
        formulas {
          id
          name
          priceType
          perPersonPrice
          roomPrices {
            single
            double
            triple
            quadruple
            quintuple
          }
        }
        agency {
          id
          name
          subdomain
          domainType
          logo
          rating
          verified
          theme {
            primaryColor
            secondaryColor
          }
        }
        airline {
          id
          name
          code
          logo
        }
      }
    }
  }
`; 